'use client';

var DEFAULT_STYLE_OPTION = {
    primaryBtnStyle: 'primary',
    secondaryBtnStyle: 'default',
    primaryBtnOutline: 'solid',
    secondaryBtnOutline: 'solid',
    size: 'md',
    isCenterTitle: false,
    closeButtonPosition: 'right',
    className: '',
    bodyDivQuerySelector: '',
    isPushViewBehind: false,
    isFooterButtonFullWidth: false,
    headerBg: '#fff',
    closeIconColor: '#888',
    headerTextColor: '#333',
    isHaveBorder: true,
    primaryBtnWidth: '',
    isDisplayNone: false
};
var DEFAULT_OPTION = {
    isShowBackdrop: true,
    isCloseOnClickBackdrop: true,
    isShowClose: true,
    isFullScreenOnMobile: true,
    isShowSecondaryButton: true,
    isShowPrimaryButton: true,
    isCenterFooter: false,
    isReverseAction: false
};
var DEFAULT_HEIGHT_FIX = 135;

export { DEFAULT_HEIGHT_FIX, DEFAULT_OPTION, DEFAULT_STYLE_OPTION };
//# sourceMappingURL=constants.js.map
